import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-content-view',
    templateUrl: './content-view.component.html',
    styleUrls: ['./content-view.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ContentViewComponent implements OnInit {
  @Input() text: String;
  constructor() {}

  ngOnInit() {}
}
